import { AxiosResponse } from 'axios';
import BaseAPI from "../api";

const path: string = "/class-room-student";

export type listType = {
  degree?: string;
  faculty?: string;
  date_of_issue?: string;
  year_graduated?: string;
  status?: string;
  created_id?: string;
  created_date?: string;
  modified_id?: string;
  modified_date?: number;
  type?: string;
  limit?: number;
  page?: number;
  keyword?: string;
  search?: string;
};

export class classRoomStudentApi extends BaseAPI {
  static getClassRoomStudent(): Promise<AxiosResponse> {
    return this.api.get(`${path}/find-teacher`);
  }
}
